(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-gifts/assets/javascripts/redeem/components/async-route.js') >= 0) return;  svs.modules.push('/modules/ticket-gifts/assets/javascripts/redeem/components/async-route.js');
"use strict";

const {
  Fragment,
  useState,
  useEffect
} = React;
setGlobal('svs.ticket_gifts.redeem.components.AsyncRoute', _ref => {
  let {
    todo
  } = _ref;
  const [asyncContent, setAsyncContent] = useState(false);
  useEffect(() => {
    todo(jsx => {
      setAsyncContent(jsx);
    });
  }, []);
  return React.createElement(Fragment, null, asyncContent ? asyncContent : '');
});

 })(window);